<app-card [loading]="(loading$ | async) ?? false">
  <div class="header" [formGroup]="filterForm">
    <app-input-wrapper [control]="filterForm.controls['searchTerm']">
      <app-icon input-wrapper-icon-start name="ic_search" />
      <input
        type="search"
        formControlName="searchTerm"
        [placeholder]="'default.search' | translate"
      >
    </app-input-wrapper>

    <button type="button"
            class="button icon-button end"
            (click)="toggleView()">
      @if (isListView) {
        <app-icon name="ic_list"></app-icon>
        {{ 'default.view.list' | translate }}
      } @else {
        <app-icon name="ic_tiles"></app-icon>
        {{ 'default.view.tiles' | translate }}
      }
    </button>
  </div>

  @if (isListView) {
    <div class="content grid grid-cols-3">
      @for (cistern of cisternList$ | async; track cistern.id) {
        <app-cistern-item-card navigateToDetail
          [withAnimation]="false"
          [cistern]="cistern" />
      } @empty {
        <div class="span-full">{{ 'cisterns.empty' | translate }}</div>
      }

      <app-card class="button card-button" (click)="onCreateCistern()">
        <app-text-with-icon name="ic_plus" vertical>
           {{ 'cisterns.create.title' | translate }}
        </app-text-with-icon>
      </app-card>
    </div>
  } @else {
    <div class="content">
      <table>
        <thead>
        <tr app-cistern-item-row [isHeader]="true"></tr>
        </thead>
        <tbody>
          @for (cistern of cisternList$ | async; track cistern.id) {
            <tr app-cistern-item-row [cistern]="cistern"
            (delete)="onDeleteCistern(cistern.id)"
            (edit)="onEditCistern(cistern.id)"></tr>
          } @empty {
            <tr>
              <td colspan="100%">
                {{ 'cisterns.empty' | translate }}
              </td>
            </tr>
          }
          <tr>
            <th colspan="100%">
              <div class="button center" (click)="onCreateCistern()">
                <app-text-with-icon name="ic_plus">
                  {{ 'cisterns.create.title' | translate }}
                </app-text-with-icon>
              </div>
            </th>
          </tr>
        </tbody>
      </table>
    </div>
  }

  <div class="footer">
    <app-pagination [pageSize]="filterForm.value.pageSize"
                    [totalCount]="totalCount$ | async"
                    [currentPage]="filterForm.value.page"
                    (pageChange)="onChangePage($event)"
                    [loading]="loading$ | async"/>
  </div>
</app-card>
